import React from 'react';
import ContactForm from "./ContactForm";
import GoogleMapStyle from "./GoogleMapStyle";
import { FiHeadphones, FiMail } from "react-icons/fi";

const ContactOne = () => {
    return (
        <>
            <div className="row mt--40 row--15">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="rn-contact-address mt_dec--30">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Contact Phone Number</h4>
                                        <p><a href="+91 93631 05598">+91 93631 05598</a>|<a href="+91 93630 05598">+91 93630 05598</a></p>
                                        <p><a href="tel:+04222535622">0422 253 5622</a>|<a href="tel:+04222535622">0422 253 5622</a></p>
                                        <p>Landline: <a href="0422 253 5622">0422 253 5622</a></p> 
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 col-md-12 col-12 mt--20">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Our Email Address</h4>
                                        <p><a href="krpower1045@gmail.com">krpower1045@gmail.com</a></p>
                                        <p><a href="sales@krpower.in">sales@krpower.in</a></p>
                                    </div>
                                    <div className="inner">
                                        <h4 className='title'>Business Hours:</h4>
                                        {/* <p>Mon–Sat: 9:00 AM – 6:00 PM Sunday: Closed</p> */}
                                        <p>Mon–Sat: 9:00 AM – 6:00 PM IST (Full operations)</p>
                                        <p>Sunday: 10:00 AM – 2:00 PM IST (Limited operations: emergencies and key client support only)</p>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="col-lg-12 col-md-12 col-12 mt--20">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Our Location</h4>
                                        <p>K.R. Power Supports Pvt Ltd 9A, School Road, Chinnavedampatti,Ganapathy, Coimbatore – 641 006Tamil Nadu, India</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12 mt_md--30 mt_sm--30">
                    <ContactForm formStyle="contact-form-1" />
                </div>
            </div>

            <div className="row mt--40 row--15">
                <div className="col-lg-12">
                    <GoogleMapStyle />
                </div>
            </div>
        </>
    )
}
export default ContactOne;